import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchTailoringMasterList = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/tailoringMaster/index.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {    
        
        if(res.data.try_again) {
            dispatch('fetchTailoringMasterList', payload)
        } else {
            commit('setTailoringMasterList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchTailoringMasterAutocompleteList = ({commit, dispatch}, payload) => {

    commit('toggleInventoryMasterLoadingState', true)
    axios.post('/tailoringMaster/autocomplete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(payload.sales_form_request) {
            if(res.data.response.length > 0) {
                commit('setItemAutocompleteList', res.data.response)
            } else {
                dispatch('fetchInventoryMasterAutocompleteList', payload.inventoryPayload)
            }            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleInventoryMasterLoadingState', false)
    })
}

export const fetchTailoringItemSubCategoryBased = ({commit}, payload) => {

    axios.post('/tailoringMaster/fetchTailoringItemSubCategoryBased.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setTailoringMasterList', {response: res.data.response})         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchTailoringMasterData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/tailoringMaster/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
                
        if(res.data.status) {

            if(res.data.response.auto_complete_list.length>0) {
                commit('setItemAutocompleteList', res.data.response.auto_complete_list)
            }
            
            if(payload.copy) {
                res.data.response.id = 0
                commit('displaySuccessNotification', {message: 'Data copied!!!'});                
            }
            
            commit('setTailoringMasterData', {response: res.data.response, copy: payload.copy})   
            if(res.data.response.category_id>0) {
                dispatch('fetchItemCategoryData', { id: res.data.response.category_id })
            }
            
        
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetTailoringMasterData')
        }
        dispatch('fetchTaxSetting')
            

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-Tailoring'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitTailoringMasterData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
    if(payload.id>0) {
        setTimeout(() => {
            commit('displayMessageAlert', {message: payload.template_name.trim()+"'s template is submitted, it may take a couple of mins for the update!!!", type: 'Success'})
            commit('toggleLoadingState', false)    
        }, 2000);        
    }            
    axios.post('/tailoringMaster/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            //dispatch('fetchTailoringMasterData', { id: payload.id, copy: false, navigate: false })
            commit('displaySuccessNotification', {message: 'Tailoring template saved successfully!!!'});
            if(payload.id === 0) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        
    })
}

export const deleteTailoringMasterData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
                
    axios.post('/tailoringMaster/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchTailoringMasterList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/tailoringMaster/actions.js